import { CSSProperties, useRef, useState } from "react";
import {
  Offer,
  TemplateOptionSettings,
  Template,
  CampaignType,
} from "../../../../../types/global.types";
import FeaturedForMultiple from "../FeaturedForMultiple/FeaturedForMultiple";
import { Navigation, Pagination, Controller, Autoplay } from "swiper/modules";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import "./style.scss";

SwiperCore.use([Navigation, Controller]);

interface Props {
  featuredOffers: Offer[];
  settings: TemplateOptionSettings;
  settingsTemplate: Template;
  displayOnly: boolean;
  campaignId: string;
  placementId: string;
  placementName: string;
  campaign: CampaignType;
  preEmail: string | undefined;
  setPreEmail?: (email: string) => void;
  openSingle: (
    o: Offer,
    isSave: boolean,
    isAutoEmail: boolean,
    slot: number,
    isShare?: boolean
  ) => void;
  onAdd: (offer: Offer, value: boolean, slot: number) => void;
  layoutId: string;
  position: "top" | "middle" | "bottom";
  canAutoSendEmailFromLabel?: boolean;
  canAutoSendEmailFromMainCTA?: boolean;
  onAutoSendEmailFromLabel?: (offer: Offer, slot: number) => void;
  autoSendingOfferId?: string;
}

const MultipleFeaturedWrapperMobile = ({
  featuredOffers,
  preEmail,
  setPreEmail,
  settings,
  campaign,
  settingsTemplate,
  displayOnly,
  campaignId,
  placementId,
  placementName,
  openSingle,
  onAdd,
  layoutId,
  position,
  canAutoSendEmailFromLabel,
  canAutoSendEmailFromMainCTA,
  onAutoSendEmailFromLabel,
  autoSendingOfferId,
}: Props) => {
  const refNavPrev = useRef<HTMLDivElement | null>(null);
  const refNavNext = useRef<HTMLDivElement | null>(null);
  const swiperRef = useRef<any>(null);
  const [loadedIndexes, setLoadedIndexes] = useState<number[]>([0]);

  const hasAnyVoucherWithType = (offers: Offer[]): boolean => {
    return offers.some(
      (featuredOffer) =>
        featuredOffer.voucher && !!featuredOffer.voucher.voucherType
    );
  };

  return (
    <div
      className={`fm-template-swiper feature-top-compact-slider ${
        (position === "top" || position === "middle") &&
        "fm-template-swiper-top"
      } ${position === "bottom" && "fm-template-swiper-bottom"}`}
      style={
        {
          "--swiper-pagination-color":
            settings?.dealLayout.buttonBackgroundColor,
          "--swiper-pagination-bullet-inactive-color": `${settings?.dealLayout.buttonBackgroundColor}e0`,
        } as CSSProperties
      }
    >
      <Swiper
        className={`swiper-container`}
        modules={[Navigation, Pagination, Autoplay]}
        onSwiper={(swiper: SwiperClass) => {
          swiperRef.current = swiper;
        }}
        watchSlidesProgress={true}
        pagination={{
          clickable: true,
          el: ".swiper-pagination",
        }}
        navigation={{
          prevEl: refNavPrev.current,
          nextEl: refNavNext.current,
        }}
        onBeforeInit={(swiper: any) => {
          swiper.params.navigation.prevEl = refNavPrev.current;
          swiper.params.navigation.nextEl = refNavNext.current;
        }}
        slidesPerView={1}
        spaceBetween={20}
        loop={true}
        onSlideChange={(swiper: SwiperClass) => {
          setLoadedIndexes((prev) =>
            prev.includes(swiper.realIndex) ? prev : [...prev, swiper.realIndex]
          );
        }}
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
      >
        {featuredOffers.map((featuredOffer, idx) => (
          <SwiperSlide
            key={featuredOffer.id}
            style={{ color: settings?.dealLayout.textColor }}
            onClick={() => {
              if (swiperRef.current && swiperRef.current.autoplay) {
                swiperRef.current.autoplay.stop();
              }
            }}
          >
            {loadedIndexes.includes(idx) && (
              <FeaturedForMultiple
                slot={featuredOffer.slot}
                settingsTemplate={settingsTemplate}
                otherSettings={settings.otherSettings}
                campaignId={campaignId}
                placementId={placementId}
                placementName={placementName}
                offer={featuredOffer}
                offerLength={campaign.offers.length}
                settings={settings}
                openSingle={openSingle}
                onAdd={onAdd}
                setPreEmail={setPreEmail}
                preEmail={preEmail}
                displayOnly={displayOnly}
                campaign={campaign}
                isAdded={featuredOffer.isAdded || false}
                retailerId={campaign.company_Id}
                hasVoucher={
                  (featuredOffer.voucher &&
                    !!featuredOffer.voucher.voucherType) ||
                  false
                }
                hasAnyVoucherWithType={hasAnyVoucherWithType(featuredOffers)}
                layoutId={layoutId}
                layoutOptions={settings?.layoutOptions}
                canAutoSendEmailFromLabel={canAutoSendEmailFromLabel}
                canAutoSendEmailFromMainCTA={canAutoSendEmailFromMainCTA}
                onAutoSendEmailFromLabel={onAutoSendEmailFromLabel}
                autoSendingOfferId={autoSendingOfferId}
              />
            )}
          </SwiperSlide>
        ))}
        <div className="swiper-navigation multiple-featured-wrapper-mobile-navigation">
          <div className="swiper-pagination"></div>
        </div>
      </Swiper>
    </div>
  );
};

export default MultipleFeaturedWrapperMobile;
